import { DM_Mono, DM_Sans, Libre_Baskerville, Open_Sans } from 'next/font/google'

const OpenSans = Open_Sans({
  subsets: ['latin'],
  weight: ['300', '400', '500', '600', '700'],
  variable: '--font-open-sans',
})

const DMMono = DM_Mono({
  subsets: ['latin'],
  weight: ['300', '400', '500'],
  variable: '--font-dm-mono',
})

const DMSans = DM_Sans({
  subsets: ['latin'],
  weight: ['300', '400', '500', '600', '700'],
  variable: '--font-dm-sans',
})

const LibreBaskerville = Libre_Baskerville({
  subsets: ['latin'],
  weight: ['400', '700'],
  variable: '--font-libre-baskerville',
})

const fontsVariables = `${DMSans.variable} ${LibreBaskerville.variable} ${DMMono.variable}`

const fonts = {
  DMMono,
  DMSans,
  LibreBaskerville,
  OpenSans,
  variables: fontsVariables,
}

export default fonts
